import { colors } from "@dotnet/telematics-design-system";

import { CreditsDto } from "./LeftSide/types";
import { StatusWidgetDto } from "./shared/DeviceStatus/types";

export const DoughnutTopAlignment = "48";
export const DoughnutCenterItemsLineHeight = "16";

const getTotal = (statusData: StatusWidgetDto | CreditsDto | null) => {
  if (!statusData) return 0;

  if ("totalCount" in statusData) return statusData.totalCount ?? 0;
  if ("total" in statusData) return statusData.total ?? 0;

  return 0;
};

export const createEmptyDoughnut = (
  statusData: StatusWidgetDto | CreditsDto | null,
  cancelDraw?: boolean
) => ({
  id: "emptyDoughnut",
  afterDraw(chart: any, _args: any, options: any) {
    const total = getTotal(statusData);

    if (total > 0 || cancelDraw) return;

    const {
      chartArea: { left, right, top, bottom },
      ctx
    } = chart;

    const centerX = (left + right) / 2;
    const centerY = (top + bottom) / 2;
    const radius = Math.min(right - left, bottom - top) / 2;

    ctx.save();
    ctx.beginPath();
    ctx.lineWidth = options?.width ?? 20;
    ctx.strokeStyle = options?.color ?? colors.gray300;
    ctx.arc(
      centerX,
      centerY,
      radius - (options?.radiusDecrease ?? 10),
      0,
      2 * Math.PI
    );
    ctx.stroke();
    ctx.restore();
  }
});

export const createEmptyBarChart = (
  statusData: number | undefined,
  isLimitReached?: boolean
) => ({
  id: "emptyBarChart",
  afterDraw(chart: any) {
    if (statusData === undefined) return;

    // When limit is reached, draw the red state,
    // regardless of the current credits amount.
    if (!isLimitReached && statusData > 0) return;

    const {
      chartArea: { left, right, top, bottom },
      ctx
    } = chart;

    const barHeight = 16;
    const centerY = top + (bottom - top) / 2;

    ctx.save();

    ctx.fillStyle = isLimitReached ? colors.red700 : colors.gray300;

    ctx.fillRect(left, centerY - barHeight / 2, right - left, barHeight);

    ctx.restore();
  }
});

export const emptyDoughnutStyles = (cutout: number) => {
  return {
    color: colors.gray300,
    width: 20,
    radiusDecrease: 10,
    cutout: cutout
  };
};
